import { SearchRequest } from '@kimuno/api-sdk/lib/types/requests/Common';
import { MindItemSearchResult } from '@kimuno/api-sdk/lib/types/responses/MindItem';
import { SearchResponseData } from '@kimuno/api-sdk/lib/types/responses/Common';
import { ThunkAction } from './common.actionTypes';
import { FETCH_DASHBOARD_WORKSHEETS, FetchDashboardWorksheetsAction } from './dashboard.actionTypes';
import services from '../services';
import { SearchFilters } from '../types/search';

export const DASHBOARD_WORKSHEETS_LIMIT = 20;

// Worksheet pages only — stricter than the search "Arbeitsblätter" tab
// (contentType=document); scopes literally to worksheet pages.
const WORKSHEET_FILTERS: Pick<SearchFilters, 'pageContentType' | 'sortBy'> = {
  pageContentType: ['arbeitsblatt'],
  sortBy: 'createdDate',
};

/**
 * Fetches the newest worksheet mind items across the given subjects into the
 * dashboard-scoped slice, isolated from the search page's global mind-item store.
 * No-op when no subjects are supplied.
 */
export function fetchDashboardWorksheets(
  subjects: string[],
): ThunkAction<FetchDashboardWorksheetsAction> {
  return async (dispatch) => {
    if (subjects.length === 0) return;

    const request: SearchRequest = {
      ...WORKSHEET_FILTERS,
      subject: subjects,
      offset: 0,
      limit: DASHBOARD_WORKSHEETS_LIMIT,
    };
    const payload = { subjects };

    dispatch({ type: FETCH_DASHBOARD_WORKSHEETS.START, payload });

    return services.mindItem
      .search(request)
      .then((result) => {
        dispatch({
          type: FETCH_DASHBOARD_WORKSHEETS.SUCCESS,
          result: result as SearchResponseData<MindItemSearchResult>,
          payload,
        });
      })
      .catch((error) => {
        dispatch({ error, type: FETCH_DASHBOARD_WORKSHEETS.ERROR, payload });
      });
  };
}
